import { PanelMenu } from 'primereact/panelmenu';
import { useEffect, useRef, useState } from 'react';
import { Button, Checkbox, Column, Icon, Row, Select } from '../../../components';
import TextInputWithLabelInline from '../../../shared/components/input/TextInputWithLabelInline';
import { PLEASE_SELECT } from "../../../shared/util/constant";
import * as lables from "../../../shared/util/label";
import SliderMailMergeService from './SliderMailMergeService';
import './SliderMailMerge.scss'
import { Badge } from 'primereact/badge';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../shared/store";
import * as label from '../../../shared/util/label';
//import { constant } from 'lodash';
import { MailMergeRequest } from '../../model/MailMergeRequest';
import * as constant from '../../../shared/util/constant';
import { Collapse, Container, FloatingLabel, Form, Table } from "react-bootstrap";
import useSlider from '../../../shared/components/Slider/useSlider';
import { toast } from 'react-toastify';
import { MenuItem } from 'primereact/menuitem';
import moment from 'moment';
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext';
import { InputFieldsDto } from '../../model/InputFieldsDto';
import { result } from 'lodash';
import Customer from "../../model/Customer";
import CustomerDetailService from '../../customer-details/CustomerDetailService';
import { updateCustomers } from '../../customer-slice/Customer-slice';
import Logger from '../../../shared/services/Logger';
import { cleareTabsInputs } from '../CustomerSliderContext';
import { AppEvenType, notifyAppEvent } from '../../../shared/store/component-notification/ComponentNotification';

export interface ISliderMailMerge {
    customerId?: string,
}

const SliderMailMerge: React.FunctionComponent<ISliderMailMerge> = (props) => {

    /// Get customer and lookup from redux slicer.
    const dispatch = useDispatch()

    const slider = useSlider();
    const [isPolicyIdEmpty, setIsPolicyIdEmpty] = useState(false);

    const customerId = props.customerId;
    const service = new SliderMailMergeService();
    const customerDetailService = new CustomerDetailService();

    const [selectedOption, setSelectedOption] = useState('');
    const [mergeDocData, setMergeDocData] = useState<MenuItem[]>();
    // const [isPolicyOptional, setIsPolicyOptional] = useState(true);
    const [isFormSaved, setIsFormSaved] = useState(true);
    const [custNumber, setCustNumber] = useState('');
    const [visible, setVisible] = useState(false);
    const defaultMailMergeRequest: MailMergeRequest = {
        custId: '',
        mergeDocTemplateId: '',
        policyId: '',
        languageId: '',
        printNow: true,
        addToQueue: false,
        search: '',
        indexkey1: '',
        indexkey2: '',
        userId: '',
        attributes: '',
        inputFields: []
    }
    const [mailMergeRequest, setMailMergeRequest] = useState<MailMergeRequest>(defaultMailMergeRequest);
    const [selectedTemplateId, setSelectedTemplateId] = useState(mailMergeRequest.mergeDocTemplateId);
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [activeItem, setActiveItem] = useState<string | null>(null);
    const prevActiveItemRef = useRef<string>(null);
    const customerSummary = useSelector((state: any) => state.customerSlice);
    const [termArray, setTermArray] = useState<any[]>([]);
    const [policysaveDetails, setPolicySaveDetails] = useState<any[]>([]);
    const userDetails = useSelector((state: any) => state.userContextSlice);
    let mailMergeSliderState = useSelector((state: RootState) => state?.CustomerSliderState);
    const [inputFieldDetails, setInputFieldDetails] = useState<InputFieldsDto[]>(); // Saving the inputs from User and use it as parameter
    const [dynamicInputs, setDynamicInputs] = useState<any[]>([]); // Fetching the dynamin input fields from API
    const [templateFileName, setTemplateFileName] = useState<any>(); // Saving the selected template file name
    const policiesForSelect = [...mailMergeSliderState.activityPage.policiesForSelect];
    const hasPolicyOptions = (policiesForSelect?.length ?? 0) > 0;


    let customerInfo = useSelector((state: RootState) => state?.customerSlice);

    useEffect(() => {
        (async () => {
            if (!(customerInfo.customer.id === customerId && (customerInfo.customer.id !== null && customerInfo.customer.id !== undefined))) {
                let customerData = await customerDetailService.fetchCustomerById(customerId);
                dispatch(updateCustomers(customerData))
            }
        })();
    }, [customerInfo]);

    //static drowdown value
    const setRequestDetails = (value: string | Date) => {
        if (value) {
            const termsForPolicy = policiesForSelect
                .filter(term => term.value === value)
                .map(term => {
                    return {
                        policyNumber: term.originalData.policyNumber,
                        value: term.originalData.policyId,
                        label: `Term: ${moment(term.originalData.polEffDate).format("MM/DD/YYYY")} to ${moment(term.originalData.polExpDate).format("MM/DD/YYYY")}`,
                        polEffDate: term.originalData.polEffDate,
                        polExpDate: term.originalData.polExpDate,
                    };
                });
            setPolicySaveDetails(termsForPolicy);
        } else {
        setPolicySaveDetails([]);
        }
    }

    const onFieldChange = (name: string, value: string | Date) => {
        if (name === 'policyId') {
            setRequestDetails(value);
        }

        setMailMergeRequest({
            ...mailMergeRequest,
            [name]: value,
        })
        setIsFormSaved(false);

    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setInputFieldDetails({
            ...inputFieldDetails,
            [name]: value,
        });
    }

    const onCancelClick = async () => {
        dispatch(cleareTabsInputs());
         setMailMergeRequest({
            ...mailMergeRequest,
            search: '',
        })
    }

    const downloadPDF = async (data) => {
        if (!data || (data instanceof Blob && data.size === 0)) {
            Logger.logError('No data provided for PDF download.');
            return;
        }
        try {
            const file = new Blob(
                [data],
                { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);

            // Code for downloading the file to local
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', `${templateFileName}_${customerInfo.customer.custNumber}.pdf`); // Set desired filename
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            Logger.logError('Error downloading PDF:', error);

        }
    };



    const onSaveClick = async (isPopUp: boolean) => {
        try {
            const policyValue = String(mailMergeRequest.policyId || '').trim();
            if (hasPolicyOptions &&!policyValue) {
                setIsPolicyIdEmpty(true);
                return;
            }
            setIsPolicyIdEmpty(false);
            let attributes = policysaveDetails[0]
                ? { term: `${moment(policysaveDetails[0].polEffDate).format("MM/DD/YYYY")} to ${moment(policysaveDetails[0].polExpDate).format("MM/DD/YYYY")}` }
                : "";
            const allItems = mergeDocData.flatMap(data => data.items);
            const matchedItem = allItems.find(item => item.id === selectedTemplateId);

            let docCategory = mergeDocData.find(docItem => {
                let catgItem  = docItem.items.find(letterItem => letterItem.id == matchedItem.id);
                if (catgItem) {
                    return true;
                }
                return false;
            });
                
            let userId = userDetails.userContext.id;
            mailMergeRequest.indexkey1 = custNumber;
            mailMergeRequest.indexkey2 = policysaveDetails[0]?.policyNumber || ''; 
            mailMergeRequest.userId = userId;
            mailMergeRequest.attributes = attributes ? JSON.stringify(attributes) : "";
            mailMergeRequest.mergeDocID = matchedItem ? matchedItem.mergeDocID : '';
            mailMergeRequest.savePrintedDocument = matchedItem ? matchedItem.savePrintedDocument : false;
            mailMergeRequest.documentTypeId = matchedItem ? matchedItem.documentTypeId : '';
            let createdActivity = null;
            if (!isPopUp) {
                const inputFields = await service.getInputFields(mailMergeRequest.mergeDocTemplateId);
                if (!isObjectEmpty(inputFields)) {
                   setVisible(true);
                   setInputFieldDetails(inputFields);
                   setDynamicInputs(inputFields);
                }
                else {
                    const data = await service.getMergeDocument(mailMergeRequest);
                    createdActivity = await service.createActivityForDocumentGenerated(mailMergeRequest, `${docCategory?.label} | ${matchedItem.label}`);
                    downloadPDF(data);
                }
            }
            else {
                const data = await service.getMergeDocument(mailMergeRequest);
                createdActivity = await service.createActivityForDocumentGenerated(mailMergeRequest, `${docCategory?.label} | ${matchedItem.label}`);
                downloadPDF(data);
                setVisible(false);
            }
            
            if (createdActivity) {
                dispatch(notifyAppEvent({ eventType: AppEvenType.NewCustomerActivityCreated, eventData: createdActivity }));
            }

        } catch (error) {
            Logger.logError('Error fetching mail merge data:', error);

            toast.error('Failed to download Mail merge template. Please try again.');
            return null;
        }
    }

    const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0; // Returns true if the object is empty
    };


    const onSavePopUpClick = async () => {
        let errorMessage = '';
        Object.entries(inputFieldDetails).forEach(([key, value]) => {
            if (value.toString() == "") {
                errorMessage = "Please enter all the fields";
                return;
            }
            else {
                errorMessage = '';
            }
        });
        if (errorMessage == "") {
            mailMergeRequest.inputFields = inputFieldDetails;
            onSaveClick(true);
        }
        else {
            if (errorMessage) {
                toast.error("Please enter all the fields");
                return;
            }
        }
    }


    useEffect(() => {
        setCustNumber(customerSummary.customerSummary?.custNumber || '');
        setMailMergeRequest({
            ...mailMergeRequest,
            ['custId']: customerId,
        })
        initializeComponent();
         if(policiesForSelect.length === 1){
               const defaultPolicyId = mailMergeRequest.policyId || policiesForSelect[0].value
            // Set the first policy as default if not already set
            setMailMergeRequest(prev => ({
                ...prev,
                policyId: prev.policyId || policiesForSelect[0].value
            }));
            setRequestDetails(defaultPolicyId);
        }
        else {
            const defaultPolicyId = mailMergeRequest.policyId || '' ;
            setMailMergeRequest(prev => ({
                ...prev,
                policyId: prev.policyId || '' 
            }));
            setRequestDetails(defaultPolicyId);
        }
    }, []);


    const itemRenderer = (item) => {
        return (
            <div
                id={"header_" + item.id}
                className="p-panelmenu-header-content headerTemplate"
                data-pc-section="headercontent"
            >
                <a href="#" className="p-panelmenu-header-link" data-pc-section="headeraction">
                    <Icon icon={`${selectedGroupId === item.id ? 'down-arrow' : 'right-arrow'}`}></Icon>
                    <span className="p-menuitem-text" data-pc-section="headerlabel" style={{ fontFamily: "&quot;Roboto Condensed sans-serif&quot;" }}>
                        <span className={`mx-2 ${item.items && item.items.length > 0 ? 'font-semibold' : ''}`}>
                            {item.label}
                        </span>
                    </span>
                </a>
            </div>
        );
    };

    const subItemRenderer = (item) => {
        return (

            <div id={item.id} className="flex align-items-center px-2 py-2 cursor-pointer" onClick={() => { setSelectedTemplateId(item.id); setMergeTemplateDetail(item.id, item.label); }}>
                <span id={"Span_" + item.id} data-max-length="10" title={item.label} className={`mx-2 ul-truncate ${item.items && 'font-semibold'} cursor-pointer`}>{item.label}</span>
            </div>
        );
    };

    async function initializeComponent(): Promise<void> {
        let data = await service.getMergeDocGroup();
        data.forEach((item) => {
            item.template = (options) => itemRenderer(item, options);
            item.command = () => {
                setSelectedTemplateId('');
                setMergeTemplateDetail('', '');
        }
            if (item.items && item.items.length > 0) {
                item.items.forEach((subItem) => {
                    subItem.template = (options) => subItemRenderer(subItem, options);
                    subItem.command = () => {
                        setSelectedTemplateId(subItem.id);
                        setMergeTemplateDetail(subItem.id, subItem.label);
                    }
                });
            }
        });

        setMergeDocData(data);
    }

    const manageActiveToggle = (event) => {
        if (event.target.checked) {
            onFieldChange("printNow", event.target.checked)
        }
        else {
            onFieldChange("printNow", event.target.checked)
        }
    }
    const setMergeTemplateDetail = async (templateId: any, templateFileName: any): Promise<any> => {
        try {
            setMailMergeRequest(prev => ({
                ...prev,
                mergeDocTemplateId: templateId
            }));
            setTemplateFileName(templateFileName);
            setHighlighted(templateId);
        } catch (error) {
            Logger.logError('Error fetching merge template detail:', error);

            return null;
        }
    };

    const setHighlighted = (itemId) => {
        if (activeItem === itemId) {
            return;
        }
        else {
            setActiveItem(itemId);
            const divElement = document.getElementById(itemId);
            const parentLi = divElement.closest("li");
            parentLi.classList.add('p-highlight');
        }
    };

    useEffect(() => {
        const prevActiveItem = prevActiveItemRef.current;
        if (prevActiveItem && prevActiveItem !== activeItem) {
            const divElementOld = document.getElementById(prevActiveItem);
            if (divElementOld) {
                const parentLiOld = divElementOld.closest("li");
                if (parentLiOld.classList.contains('p-highlight')) {
                    parentLiOld.classList.remove('p-highlight');
                }
            }
        }
        prevActiveItemRef.current = activeItem;
    }, [activeItem]);

    let popupContent = <>
        <div className="modal-content">
            <div className="modalHeader modal-header">
                <div className="modal-title h4">Mail Merge</div>
                </div>

            <div className="modal-body">
            <Row className="mb-2 sld-mailmerge-action-row">
                {
                    Object.entries(dynamicInputs).map(([key, value], index) => (
                        <Column lg={12} md={12}>
                            <InputText
                                id={key}
                                key={key}
                                type="input"
                                name={key}
                                placeholder={key}
                                onChange={handleChange}
                                maxLength={225}
                                className='texbox-input mb-3'
                            />
                        </Column>
                    ))
                }
                </Row>
                <div className="modal-footer" style={{ justifyContent: 'flex-end', display: 'contents' }}>
            <Row className="mb-2 sld-mailmerge-action-row">
                <Column lg={6} md={6} className="sld-task-col">
                    <Button
                        className='btn btn-outline-tertiary sld-action-btn-base'
                        key="btnSliderPopupCancel"
                        onClick={() => setVisible(false)}
                        id="btnSliderPopupCancel"
                        color='primary'
                        outlined={true}
                    >Cancel
                    </Button>
                </Column>
                <Column lg={6} md={6} className="sld-task-col  text-right">
                    <Button
                        className='sld-action-btn-base'
                        key="btnSliderPopupSave"
                        onClick={() => onSavePopUpClick()}
                        id="btnSliderPopupSave"
                        color='primary'
                        outlined={true}
                    >Submit
                    </Button>
                </Column>
            </Row>
            </div></div>
        </div>
    </>;

    let mainContent = <>
        <Row>
            <Column lg={12} md={12} className="" style={{ paddingBottom: '10px' }}>
                <span className="sld-task-section-header">{lables.CustomerMailMergeLabel.MAIL_MERGE}</span>
            </Column>
        </Row>

        {/* <Row>
            <Column lg={12} md={12}>
                <Select
                    label='Language'
                    id={'languageId'}
                    placeholder={PLEASE_SELECT}
                    options={dropdownOptions !== undefined ? dropdownOptions : []}
                    onChange={(values) => { onFieldChange('languageId', values[0] as string); }}
                    defaultSelected={dropdownOptions.filter(item => item.value == selectedOption)}
                    isRequired={true}
                    sortOptions={false}
                    className='mb-3'
                    showAsFloatingLabel={true}
                    multiple={false} />
            </Column>
        </Row> */}
        <Row>
            <Column lg={12} md={12}>
                <Select
                    id='policyId'
                    label={label.CustomerActivityLabel.POLICY_SELECT}
                    options={policiesForSelect ?? []}
                    defaultSelected={policiesForSelect?.filter(({ value }) =>
                        String(value) === String(mailMergeRequest.policyId)
                    ) ?? []}
                    tabIndex={1001}
                    onChange={(values) => {
                        onFieldChange('policyId', values[0] as string)
                    }}
                    placeholder={label.PLEASE_SELECT}
                    multiple={false}
                    showAsFloatingLabel={true}
                    className='mb-3'
                    isInvalid={isPolicyIdEmpty && hasPolicyOptions}
                    invalidWarning={isPolicyIdEmpty && hasPolicyOptions ? constant.FIELD_BLANK : ""}
                    invalidLableClass="lable-error sld-act-input-error"
                    isRequired={hasPolicyOptions}
                    sortOptions={false}
                />
            </Column>
        </Row>

        <Row>
            <Column lg={12} md={12}>
                <FloatingLabel controlId="search" label='Search'>
                    <Form.Control
                        type="text"
                        name="Search"
                        placeholder='Search'
                        value={mailMergeRequest.search}
                        onChange={(event) => onFieldChange('search', event.currentTarget.value)}
                        tabIndex={1002}
                        maxLength={50}
                        className='texbox-input mb-3'
                    />
                </FloatingLabel>
            </Column>
        </Row>
        <Row className="paneelCardRow mb-3">
            <Column>
                <div className="row">
                    <div className="col-lg-12 overflow-auto">
                        <div className="paneelCard flex justify-content-center">
                            <PanelMenu
                                model={mergeDocData}
                                className="w-full md:w-20rem"
                                multiple={false}
                                pt={{ headerAction: { tabIndex: 1003 } }}
                            />
                        </div>
                    </div>
                </div>
            </Column>
        </Row>
        <Row>
            <Column>
                <Checkbox
                    id='printNow'
                    label={<><span style={{ paddingLeft: '5px' }}>Print Now</span></>}
                    checked={mailMergeRequest.printNow ?? false}
                    disabled={false}
                    className="formcheck-nopadding mb-3"
                    checkboxStyle={{ position: "relative", marginLeft: "0px" }}
                    onChange={(event) => manageActiveToggle(event)}
                    tabIndex="1004"
                />
            </Column>
        </Row>

        {//<Row>
        //    <Column>
        //        <Checkbox
        //            id='AddToQueue'
        //            label={<><span style={{ paddingLeft: '5px' }}>Add To Queue</span></>}
        //            checked={true}
        //            onChange={() => { }}
        //            disabled={false}
        //            className="formcheck-nopadding mb-3"
        //            checkboxStyle={{ position: "relative", marginLeft: "0px" }}
        //        />
        //    </Column>
        //</Row>
        /* Action Row */}
        <Row className="mb-2 sld-mailmerge-action-row">
            <Column lg={6} md={6} className="sld-task-col">
                <Button
                    className='btn btn-outline-tertiary sld-action-btn-base'
                    key="btnSliderMailMergeCancel"
                    onClick={() => onCancelClick()}
                    id="btnSliderMailMergeCancel"
                    color='primary'
                    outlined={true}
                    tabIndex={1005}
                >{lables.StandardSearchLable.RESET.toLocaleUpperCase()}
                </Button>
            </Column>
            <Column lg={6} md={6} className="sld-task-col  text-right">
                <Button
                    className='sld-action-btn-base'
                    key="btnSliderMailMergeSave"
                    onClick={() => onSaveClick(false)}
                    tabIndex={1006}
                    id="btnSliderMailMergeSave"
                    color='primary'
                    disabled={!mailMergeRequest.mergeDocTemplateId || mailMergeRequest.mergeDocTemplateId === ''}
                >Submit
                </Button>
            </Column>
        </Row>
    </>;

    return (
        <div>
            {mainContent}
            <Dialog 
                visible={visible}
                modal
                onHide={() => { if (!visible) return; setVisible(false); }}
                content={popupContent}
            ></Dialog>
        </div>
    );

}

export default SliderMailMerge;